<template>
  <div>
    <b-row>
      <ServerError v-if="ServerError" />
      <vue-element-loading :active="appLoading" :is-full-screen="true">
        <img src="../../assets/loader.gif" />
      </vue-element-loading>
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card>
            <div slot="header">
              Tree Cut Reportings 
            </div>
            <b-table
              v-if="incidents.length > 0"
              :hover="true"
              :striped="true"
              :bordered="false"
              :small="false"
              :fixed="false"
              responsive="sm"
              :items="incidents"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
            >
               <template slot="HEAD_total" >
                <span><i class="fa fa-square fa-2x " Style="color:#cccccc" aria-hidden="true"></i></span>
              </template>
              <template slot="HEAD_beencut" >
                <span><i class="fa fa-square fa-2x " Style="color:#E25151" aria-hidden="true"></i></span>
              </template>
              <template slot="HEAD_mightbecut">
                <span ><i class="fa fa-square fa-2x " Style="color:#FC9941" aria-hidden="true"></i></b-button
                ></span>
              </template>
              <template slot="HEAD_havebeencut">
                <span><i class="fa fa-square fa-2x " Style="color:#6E6E6E" aria-hidden="true"></i></b-button
                ></span>
              </template>
              <template slot="total" slot-scope="data">
              <div class="text-center">
                <span >{{data.item.beencut + data.item.havebeencut + data.item.mightbecut }}</span>
               
              </div>
            </template>
              <template slot="beencut" slot-scope="data">
                <div class="text-center">
                  <span >{{ data.item.beencut }}</span>
                  
                </div>
              </template>
              <template slot="caseid" slot-scope="data">
                <div class="text-center">
                  <span v-if="data.item.caseidentifier">{{ data.item.caseidentifier }}</span>
                  <span v-else>{{ data.item.caseid }}</span>
                </div>
              </template>
              <template slot="createddate" slot-scope="data">
                <div class="text-left">
                  <span v-if="data.item.createddate">{{
                    formatDate(data.item.createddate)
                  }}</span>
                  <span v-else>-</span>
                </div>
              </template>
              <template slot="havebeencut" slot-scope="data">
                <div class="text-center">
                  <span>{{
                    data.item.havebeencut
                  }}</span>
                 
                </div>
              </template>
              <template slot="isanonymous" slot-scope="data">
                <!-- <span v-if="data.item.isanonymous">{{data.item.isanonymous}}</span>
                <span v-else>-</span>-->
                <div class="text-center">
                  <span v-if="data.item.isanonymous">Yes</span>
                  <span v-else>No</span>
                </div>
              </template>
              <template slot="locationname" slot-scope="data">
                <div class="text-left">
                  <span v-if="data.item.locationname">{{
                    data.item.locationname
                  }}</span>
                  <span v-else>-</span>
                </div>
              </template>
              <template slot="mightbecut" slot-scope="data">
                <div class="text-center">
                  <span >{{
                    data.item.mightbecut
                  }}</span>
                  
                </div>
              </template>
              <template slot="addedby" slot-scope="data">
                <div class="text-left">
                  <span v-if="data.item.addedby.name">{{
                    data.item.addedby.name
                  }}</span>
                  <span v-else>-</span>
                </div>
              </template>
                <template slot="Pictures" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.photos">{{
                  data.item.photos.length
                }}</span>
                <span v-else>-</span>
              </div>
            </template>
            <template slot="Watchers" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.watchcount">{{
                  data.item.watchcount
                }}</span>
                <span v-else>-</span>
              </div>
            </template>
            <template slot="Comments" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.commentcount">{{
                  data.item.commentcount
                }}</span>
                <span v-else>-</span>
              </div>
            </template>
            </b-table>
            <div v-else>
              <b-row class="p-4">
                <b-col cols="12" class="text-center">
                  <span style="font-size: 18px; font-weight: 500"
                    >No Items Found</span
                  >
                </b-col>
              </b-row>
            </div>
            <nav>
              <b-pagination
                v-if="incidents.length > 0"
                size="sm"
                :total-rows="incidents.length"
                :per-page="perPage"
                v-model="currentPage"
                prev-text="Prev"
                next-text="Next"
                hide-goto-end-buttons
              />
            </nav>
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["id"],
  data: () => {
    return {
      incidents: [],
      fields: [
        { key: "caseid", label: "Case ID", sortable: true },
        { key: "createddate", label: "Created On", sortable: true },
        {
          key: "total",
          label: "Total",
          sortable: true,
          class: "text-center",
        },
        {
          key: "beencut",
          label: "Being Cut",
          sortable: true,
          class: "text-center",
        },
        {
          key: "mightbecut",
          label: "Might be cut",
          sortable: true,
          class: "text-center",
        },
        {
          key: "havebeencut",
          label: "Have Been Cut",
          sortable: true,
          class: "text-center",
        },
        // { key: "isanonymous", label: "is Anonymous", sortable: false },
        {
          key: "locationname",
          label: "Location",
          sortable: true,
          align: "center",
          tdClass: "tdwidth",
        },
        {
          key: "Pictures",
          label: "Pictures",
          sortable: true,
          class: "text-left",
        },
        {
          key: "Watchers",
          label: "Watchers",
          sortable: true,
          class: "text-left",
        },
        {
          key: "Comments",
          label: "Comments",
          sortable: true,
          class: "text-left",
        },
        { key: "addedby", label: "Added By", sortable: true },
      ],
      idset:[],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/incident/similar",
        method: "GET",
        params: {
          id: this.id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.incidents = response.data.data;
            for (var i = 0; i < this.incidents.length; i++) {
              this.idset[i] = this.incidents[i]._id;
            }
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    rowClicked(item) {
      this.$router.push("/Cases/" + item._id + "/" + this.idset);
    },
  },
};
</script>

<style >
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.tdwidth {
  width: 20% !important;
}
</style>
